import { Component, OnInit } from '@angular/core';
import { Utility } from './../../Common/Services/utility';
import { AppMessage } from './../../Common/appMessage';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent {
  logoutNote: string;
  constructor(private _utility: Utility, private appMessage : AppMessage) { }

  ngOnInit() {
    this._utility.clearLoaderCount(); // Clear loader count so that loader should not display for this page at any way
    this.logoutNote =  this.appMessage.getItem['UMsg00090'];
    this._utility.setUserLoggedInStatus(false);
  }
}






// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/logout/logout.component.ts